import React, {Component} from 'react'
import DocsBaseURL from "./DocsBaseURL";
import { Menu, Segment } from 'semantic-ui-react';
import DocsOldGetIndex from './DocsOld/DocsOldGetIndex'

class DocsDisplayPrevious extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayType: 'GET Data'
        }

        this.handleItemClick = this.handleItemClick.bind(this);
    }

    handleItemClick(e, { name }){
        this.setState({
            displayType: name
        })
    }

    render() {
        const activeItem = this.state.displayType;

        return (
            <div>
                <h3>API Version: <span style={{color: 'red'}}>{this.props.apiVersion} <i style={{color: 'gray'}}>deprecated</i></span></h3>
                <br/>
                <h3>Base URL (both supported)</h3>
                <DocsBaseURL url="api/data/"/>
                <br/>
                <DocsBaseURL url="api/data/" old />
                <br/>
                <Menu attached='top' tabular>
                    <Menu.Item
                        name='GET Data'
                        active={activeItem === 'GET Data'}
                        onClick={this.handleItemClick}
                    />
                </Menu>
                <Segment attached='bottom'>
                    {activeItem === "GET Data" ? <DocsOldGetIndex/> : null}
                </Segment>
                <br/><br/><br/><br/>
            </div>
        )
    }
}

export default DocsDisplayPrevious